import { Button, Flex, Text, Anchor } from '@mantine/core';
import classes from './employeList.module.scss';
import { EmployeCard } from '@widgets/employe';
import { IconArrowUpRight } from '@tabler/icons-react';
import { NavLink, useParams } from 'react-router';
import { useGetUsersWithPagination } from '@entities/user/api/hooks';
import { PaginateType } from '@shared/types';
import { WithFallback } from '@shared/ui';

export const EmployeList = () => {
  const { id } = useParams();
  const { data: usersData, isLoading: isUsersLoading } =
    useGetUsersWithPagination({
      filter: {
        ['company.id']: Number(id),
      },
      paginate: PaginateType.DEFAULT,
    });

  return (
    <Flex
      className={classes.wrapper}
      gap={24}
      direction='column'
      maw={418}
      miw={{ base: 'auto', sm: '25.5rem' }}
    >
      <WithFallback data={usersData} isLoading={isUsersLoading}>
        {usersData => (
          <>
            <Flex direction='column' gap={16}>
              <Flex w='100%' justify='space-between' wrap='wrap'>
                <Text size='lg' fw={600}>
                  Сотрудники компании
                </Text>

                <Button
                  variant='subtle'
                  rightSection={<IconArrowUpRight size={20} />}
                  className={classes.allButton}
                  component={NavLink}
                  to={`/?companyName=${id}`}
                >
                  Все ({usersData.data.length})
                </Button>
              </Flex>

              <Text c='tertiary.7'>
                Управление сотрудниками компании осуществляется в разделе{' '}
                <Anchor component={NavLink} to='/'>
                  пользователи
                </Anchor>
              </Text>
            </Flex>

            <Flex direction='column' gap={12}>
              {usersData.data.slice(0, 3).map(user => (
                <EmployeCard
                  src={user.profile.avatar?.absolutePath || ''}
                  key={user.id}
                  id={user.id}
                  name={user.profile?.firstName}
                  lastName={user.profile?.lastName}
                  phone={user.profile?.phone}
                  isActive={user.isActive}
                />
              ))}
            </Flex>
          </>
        )}
      </WithFallback>
    </Flex>
  );
};
